import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import EmissaoProtocoloCard from './components/EmissaoProtocoloCard';

const EmissaoProtocoloMain = () => (
  <Container fluid>
    <Row>
      <Col md={12}>
        <PageHeader
          title=""
          routeSegments={[
            { name: 'Início' },
            { name: 'Programação' },
            { name: 'Emissão de protocolo' }
          ]}
        />
      </Col>
    </Row>

    <Row>
      <Col md={12}>
        <EmissaoProtocoloCard />
      </Col>
    </Row>
  </Container>
);

export default EmissaoProtocoloMain;
